'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _GoogleDFP = require('./GoogleDFP');

var _GoogleDFP2 = _interopRequireDefault(_GoogleDFP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GoogleDFP2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/GoogleDFP/index.js
// module id = 266
// module chunks = 11